export default "__VITE_ASSET__BGptwOm5__"